module.exports = __webpack_public_path__ + "img/swiper1.c0f13a82.png";